module.exports = __webpack_public_path__ + "img/Intranet_logo.b5f778f0.png";